@if (!isEpcotEnabled()) {
    @if (!showOptionPick()) {
        <vn-icon name="theme-radio-off" class="radio-bullet" size="8" />
    }
    <div class="popular-bets-pod-event">
        @if (logoDetails()) {
            <ms-popular-bets-pod-event-logo [logoDetails]="logoDetails()" [sportId]="event().sport.id" [showLogoColor]="false" />
        }
        <div class="popular-bets-option-container">
            <span class="option-name" [class.option-name__selection-info]="showSelectionInfo">{{ selectionInfo() }}</span>
            @if (!showSelectionInfo) {
                <div class="event-and-timer">
                    {{ eventTitle() }} |
                    <ms-event-timer [live]="event().live" [start]="event().startDate" [scoreboard]="event().scoreboard" [isDynamicTimer]="true" />
                </div>
            }
        </div>
    </div>
    <ng-container *ngTemplateOutlet="eventPick" />
} @else {
    <div class="popular-bets-pod-event-container">
        <div class="popular-bets-pod-event-detail">
            @if (logoDetails()) {
                <ms-popular-bets-pod-event-logo [logoDetails]="logoDetails()" [sportId]="event().sport.id" />
            }
            <div class="popular-bets-pod-event">
                <span
                    class="option-name"
                    [class.option-name__selection-info]="showSelectionInfo"
                    [class.popular-bets-pod-event-long-text]="!showOptionPick()"
                    >{{ selectionInfo() }}</span
                >
                @if (!showSelectionInfo) {
                    <span class="popular-bets-pod-event-name" [class.popular-bets-pod-event-long-text]="!showOptionPick()">{{ eventTitle() }}</span>
                }
            </div>
        </div>
        <ng-container *ngTemplateOutlet="eventPick" />
    </div>
}

<ng-template #eventPick>
    @if (showOptionPick() && option()) {
        <ms-event-pick
            class="popular-bets-option"
            [option]="option()"
            [class.offline]="!option().online"
            [event]="event()"
            [optionGroup]="optionGroup()"
            [betDetails]="tracking().betDetails"
            [trackingVariant]="tracking().variant"
            [trackingPosition]="tracking().position">
            @if (!(optionGroup().online && option().online)) {
                <vn-icon name="theme-locked-i" class="lock-icon" [size]="isEpcotEnabled() ? '14' : '16'" />
            } @else {
                <div class="result-odds option-value">
                    <ms-font-resizer [defaultSize]="1" [maxChars]="6" [value]="option().nativePrice | msNativePriceFormatter" />
                </div>
            }
        </ms-event-pick>
    }
</ng-template>
